import { render, staticRenderFns } from "./SocialProgramsList.vue?vue&type=template&id=50cd5e88"
import script from "./SocialProgramsList.ts?vue&type=script&lang=ts&external"
export * from "./SocialProgramsList.ts?vue&type=script&lang=ts&external"
import style0 from "./SocialProgramsList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports